import React from 'react';
import { Button, Popconfirm, Popover, Space } from 'antd';
import { EditOutlined, InboxOutlined, PushpinFilled, PushpinOutlined } from '@ant-design/icons';
import SlidersHorizontal from 'lucide-react/dist/esm/icons/sliders-horizontal.mjs';

export default function ProjectDetailSettingsMenu({
  onArchiveProject,
  onRenameProject,
  onPinProject,
  project,
  themeTokens,
}) {
  const [open, setOpen] = React.useState(false);
  const handleRename = () => {
    setOpen(false);
    onRenameProject?.();
  };
  const handleArchive = async () => {
    await onArchiveProject?.(project);
    setOpen(false);
  };
  const handlePin = async () => {
    await onPinProject?.(project);
    setOpen(false);
  };
  const content = (
    <Space className="flare-project-detail-settings-actions" orientation="vertical" size={2}>
      {typeof onPinProject === 'function' ? (
        <Button
          block
          icon={project?.user_pinned ? <PushpinFilled /> : <PushpinOutlined />}
          onClick={handlePin}
          type="text"
        >
          {project?.user_pinned ? '取消置顶项目' : '置顶项目'}
        </Button>
      ) : null}
      <Button
        block
        icon={<EditOutlined />}
        onClick={handleRename}
        type="text"
      >
        重命名项目
      </Button>
      <Popconfirm
        cancelText="取消"
        okText="归档"
        onConfirm={handleArchive}
        title="确认归档项目？"
      >
        <Button block danger icon={<InboxOutlined />} type="text">
          归档项目
        </Button>
      </Popconfirm>
    </Space>
  );

  return (
    <Popover
      arrow={false}
      content={content}
      onOpenChange={setOpen}
      open={open}
      placement="bottomRight"
      trigger="click"
    >
      <Button
        aria-label="项目设置"
        className="flare-project-detail-settings-trigger"
        icon={<SlidersHorizontal aria-hidden="true" size={21} strokeWidth={1.8} />}
        style={{ color: themeTokens.textSecondary }}
        title="项目设置"
        type="text"
      />
    </Popover>
  );
}
